import React from 'react';
import { coreCatalogItemApi } from '@cp/entities/catalogItem';
import { useRouter } from '@cp/shared/router';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { AsyncResult, Result } from '@youhelp-ru/core';

export type ConnectFeature = (catalogItemId: number) => AsyncResult<void, unknown>;

export const useConnect = (): ConnectFeature => {
  const [connectWithAuthor] = coreCatalogItemApi.endpoints.connectWithAuthor.useMutation();
  const router = useRouter();
  const resolver = useClientWebResolver();

  return React.useCallback<ConnectFeature>(
    async (catalogItemId) => {
      console.debug('Start connect feature', catalogItemId);
      const connect = await Result.fromAsync(() => connectWithAuthor({ id: catalogItemId }).unwrap());
      return connect.mapAsync(({ dialogId }) =>
        router.navigate(resolver.resolve({ page: ClientWebPage.ProfileMessages, queryParams: { dialogId } })),
      );
    },
    [connectWithAuthor, router, resolver],
  );
};
